// extracted by mini-css-extract-plugin
export default {"root":"NetworksTableActions_root__2tNVW","action":"NetworksTableActions_action__kXcSR"};